module.exports = __webpack_public_path__ + "static/cam-30b91f846019893a8260dac60163912e.png";